import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./translation.en.json";
import translationSL from "./translation.sl.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      sl: { translation: translationSL }
    },
    lng: "sl", // Default language = Slovenian
    fallbackLng: "sl",
    interpolation: { escapeValue: false }
  });

export default i18n;